import React, { Component } from "react";
import config from "lib/fr-config";
import ColonTextButtonView from "presentational/common/ColonTextButtonView";
import { getDeviceType } from "lib/deviceInfo";
import { withStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";

const colorCss = config.css.color;
const fontCss = config.css.fontThickness;
const commonCss = config.css.commonDevice;
const desktopCss = config.css.desktop;
const mobileCss = config.css.mobile;

const {
  topAndBottomPaddingOfBtn: TOP_AND_BOTTOM_LIST_BTN_PADDING,
  sidePaddingOfBtn: SIDE_LIST_BTN_PADDING
} = commonCss.dropdownListBtn;

const CustomMenu = withStyles({
  paper: {
    borderRadius: 0,
    padding: 9
  }
})(Menu);
const CustomMenuItem = withStyles({
  root: {
    fontSize:
      getDeviceType() === "mobile"
        ? mobileCss.fontSizeOfTextBtn
        : desktopCss.fontSizeOfTextBtn,
    padding: `${TOP_AND_BOTTOM_LIST_BTN_PADDING}px ${SIDE_LIST_BTN_PADDING}px`,
    "&:focus": {
      backgroundColor: "inherit"
    },
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.04)"
    },
    minHeight: "auto",
    fontWeight: fontCss.medium
  }
})(MenuItem);

const css = {
  selectedMenuButton: {
    color: colorCss.colorOfPrimary
  },
  defaultMenuButton: {}
};

class DropdownButtonView extends Component {
  static propTypes = {
    dropdownName: PropTypes.string.isRequired,
    menuList: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
      })
    ).isRequired,
    selectedItem: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    disableLeftMargin: PropTypes.bool,
    disableRightMargin: PropTypes.bool,

    initialText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    prefixText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  static defaultProps = {
    initialText: null,
    prefixText: null,
    disableLeftMargin: false,
    disableRightMargin: false
  };

  state = {
    open: false,
    anchorEl: null
  };

  getTextOfSelectedValue() {
    const { menuList, selectedItem } = this.props;

    for (let i = 0; i < menuList.length; i++) {
      const oneObj = menuList[i];
      if (oneObj.value === selectedItem) return oneObj.text;
    }
    return null;
  }

  handleBtnClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleMenuItemClick = selectedValue => () => {
    const { dropdownName, onSelect } = this.props;
    onSelect(dropdownName, selectedValue);
    this.handleClose();
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const {
      menuList,
      selectedItem,
      disableLeftMargin,
      disableRightMargin,
      initialText,
      prefixText
    } = this.props;
    const { open, anchorEl } = this.state;
    const textOfSelectedValue = this.getTextOfSelectedValue();

    return (
      <div style={{ display: "inline-block" }}>
        <ColonTextButtonView
          disableLeftMargin={disableLeftMargin}
          disableRightMargin={disableRightMargin}
          onClick={this.handleBtnClick}
          primary={textOfSelectedValue ? prefixText : initialText}
          secondary={textOfSelectedValue || undefined}
          hidePrimary={!prefixText && !!textOfSelectedValue}
        />
        <CustomMenu
          MenuListProps={{ disablePadding: true }}
          elevation={0}
          PaperProps={{ style: { backgroundColor: colorCss.colorOfDropdown } }}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          getContentAnchorEl={null}
          open={open}
          anchorEl={anchorEl}
          transitionDuration={0}
          onClose={this.handleClose}
        >
          {menuList.map(oneObj => (
            <CustomMenuItem
              key={oneObj.value}
              style={
                oneObj.value === selectedItem
                  ? css.selectedMenuButton
                  : css.defaultMenuButton
              }
              onClick={this.handleMenuItemClick(oneObj.value)}
            >
              {oneObj.text}
            </CustomMenuItem>
          ))}
        </CustomMenu>
      </div>
    );
  }
}

export default DropdownButtonView;
